/*
 * @Author: your name
 * @Date: 2021-04-09 11:23:16
 * @LastEditTime: 2021-04-14 11:41:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\router\modules\moneyManagement.js
 */
export default [
    {
      path: '/moneyManagement_2',
      component: resolve => require(['../../views/moneyManagement_2/index.vue'], resolve),
      meta: {
        title: '资金管理'
      }
    },
    {
        path: '/accountManagement',
        component: resolve => require(['../../views/moneyManagement_2/accountManagement/accountManagement.vue'], resolve),
        meta: {
          title: '账户管理'
        }
    },
    {
        path: '/moneyMonitor_2',
        component: resolve => require(['../../views/moneyManagement_2/moneyMonitor_2/moneyMonitor_2.vue'], resolve),
        meta: {
          title: '资金监控'
        }
    },

    {
      path: '/moneyManagement_2/cashBackList',
      component: resolve => require(['../../views/moneyManagement_2/cashBackList'], resolve),
      meta: { title: '返现列表' }
    },
    {
      path: '/moneyManagement_2/downPaymentList',
      component: resolve => require(['../../views/moneyManagement_2/downPaymentList'], resolve),
      meta: { title: '直客收付款信息列表' }
    },
  ]


// WEBPACK FOOTER //
// ./src/TASMini/router/modules/moneyManagement_2.js